module.exports = __webpack_public_path__ + "img/element-contact-bg.d8ed5846.svg";